<template>
  <section class=" d-flex align-items-center" @click="afficheMessage()">
    <!-- Message -->
    <marquee class="w-100" v-if="success" behavior="" direction="left">{{
      welcome
    }}</marquee>
  </section>
</template>

<script>
export default {
  name: "message",
  data() {
    return {
      success: false,
      welcome: "Bienvenue sur la demo Kisdis"
    };
  },
  methods: {
    afficheMessage() {
      !this.success ? (this.success = true) : (this.success = false);
      return this.success;
    }
  }
};
</script>
